import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "widgets/register";
import * as QueriesQL from "queries/site-pack";

export const Sidebar = () => null;

export const Indice = () => (
  <>
    <BreadcrumbItem>Edit</BreadcrumbItem>
  </>
);

// Route, directory rule and archive — everything about a mount that can move.
//
// `packId` is not here: the name is the row's key and a rename would be a
// different row. `status` is not here either, and that is the point of it —
// the model DERIVES it from whether an archive is attached, so offering it as
// a control would let somebody mark a pack active with nothing behind it,
// which is exactly the gen-2 state this port set out to remove.
//
// Module scope, not a literal in JSX: a new `config` identity rebuilds the
// widget tree beneath the form's SchemaProvider and detaches the control being
// typed into (P139).
const EDIT_FIELDS = {
  "/Public/SitePack/Update": {
    fields: ["route", "type", "fileId"],
  },
};

export const Content = ({
  history,
  match: {
    params: { siteId, packId },
  },
}) => {
  const { base } = useSectionContext();

  return (
    <Mutation
      target={{ $ref: "/Public/SitePack/Update" }}
      mutation={QueriesQL.edit}
      update={QueriesQL.update()}
      onMutate={({ handler, state: { values } }) => {
        handler({
          variables: {
            siteId,
            packId,
            input: {
              route: values.route,
              // Sent explicitly even when nothing touched the control, and
              // defaulted to the schema's own default rather than left
              // undefined. A select renders its first option whatever the form
              // is actually carrying, so a person who agrees with what they see
              // fires no change event — and the honest reading of that screen
              // is that submitting it means the option shown.
              type: values.type || "spa",
              // "" is a REAL value here and must not be coalesced away: it is
              // how the Detach button takes a mount down without deleting the
              // pack. `?? ""` rather than `|| ""` would be the same thing for
              // a string, but this says which of the two it means.
              fileId: values.fileId === undefined || values.fileId === null
                ? ""
                : values.fileId,
            },
          },
        });
      }}
      onCompleted={() => {
        history.replace(base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ state, schema, mutate, target }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (vals) => {
      setValues(vals);
    },
    config: EDIT_FIELDS,
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Save</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
